/* KOMTO redesign (BAN-179): small behaviours for the product page.
 * - Links to an accordion (#komto-assembly, #komto-acc-*) open it before scrolling.
 * - The mobile section rail marks the section in view.
 * - "Write a review" buttons open the Judge.me form.
 * - The dimension drawing in Specs opens full size in a dialog; a tap on the drawing there zooms in.
 */
(() => {
  const openDetailsFor = (hash) => {
    if (!hash || hash.length < 2) return;
    let target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }
    // #montagevideo (shipping email, Assembly videos page) is the assembly video accordion
    if (target && target.id === 'montagevideo') {
      const acc = document.getElementById('komto-assembly');
      if (acc && !acc.open) acc.open = true;
      // lazy media above may have moved the block since the browser jumped: place it again under the sticky header
      setTimeout(() => target.scrollIntoView({ block: 'start' }), 400);
      return;
    }
    if (target && target.tagName === 'DETAILS' && !target.open) target.open = true;
  };

  const openJudgeMeForm = (productId) => {
    const jdgm = window.jdgm;
    // the modal needs Judge.me's form script too (it defines the helpers the modal calls)
    const ready = () => jdgm.$ && typeof jdgm._WriteReviewModal === 'function' && typeof jdgm._rtlStarsEnabled === 'function';
    if (typeof jdgm._WriteReviewModal !== 'function') jdgm.loadScript(`${jdgm.CDN_HOST}widget/write_review_modal.js`);
    if (typeof jdgm._rtlStarsEnabled !== 'function') {
      jdgm.loadCSS(jdgm.widgetPath('form.css'));
      jdgm.loadScript(`${jdgm.CDN_HOST}widget/form.js`);
    }
    let tries = 0;
    const wait = () => {
      if (!ready()) {
        if (tries++ < 50) setTimeout(wait, 100);
        return;
      }
      document.querySelectorAll('.jdgm-review-widget-modal.jdgm-write-review-modal').forEach((m) => m.remove());
      const modal = new jdgm._WriteReviewModal(jdgm.$);
      Promise.resolve(modal.setup('jdgm-review-widget-modal', productId)).then((ok) => { if (ok) modal.showModalPage(); });
    };
    wait();
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#komto-"]');
    if (link) openDetailsFor(link.getAttribute('href'));

    const review = event.target.closest('[data-komto-write-review]');
    if (review) {
      // With reviews, Judge.me renders its new widget and opens the form from its own primary
      // button; the old .jdgm-write-rev-link stays in the markup, hidden, and does nothing (as a
      // link to "#" it would only jump to the top). Without reviews Judge.me hides its button
      // itself. So only a visible control is clicked; otherwise the link scrolls to the widget.
      const judgeMe = Array.from(document.querySelectorAll(
        '#judgeme_product_reviews .jm-action-buttons__button.jm-button--primary, .jdgm-write-rev-link, .jdgm-rev-widg__write-rev-link, [data-jdgm-write-review]'
      )).find((el) => el.offsetParent !== null);
      if (judgeMe) {
        event.preventDefault();
        judgeMe.click();
      } else {
        // No reviews yet: Judge.me shows its old empty widget, whose write link stays hidden. Open Judge.me's own
        // write-review window the way its new widget does (owner decision 53; nothing is submitted here).
        const widget = document.querySelector('#judgeme_product_reviews[data-product-id]');
        if (widget && window.jdgm && typeof window.jdgm.loadScript === 'function') {
          event.preventDefault();
          openJudgeMeForm(widget.dataset.productId);
        }
      }
    }
  });

  const drawing = document.querySelector('[data-komto-drawing]');
  const drawingOpen = document.querySelector('[data-komto-drawing-open]');
  if (drawing && drawingOpen && typeof drawing.showModal === 'function') {
    drawingOpen.addEventListener('click', () => {
      // The full-size file loads on first open only
      const img = drawing.querySelector('[data-komto-drawing-img]');
      if (img.dataset.src && !img.getAttribute('src')) img.src = img.dataset.src;
      drawing.classList.remove('is-zoomed');
      drawing.showModal();
      drawing.querySelector('[data-komto-drawing-close]').focus();
    });
    drawing.querySelector('[data-komto-drawing-close]').addEventListener('click', () => drawing.close());
    drawing.addEventListener('click', (event) => {
      // A click on the backdrop (the dialog itself, outside its content) closes it
      if (event.target === drawing) drawing.close();
      else if (event.target.closest('[data-komto-drawing-img]')) drawing.classList.toggle('is-zoomed');
    });
    drawing.addEventListener('close', () => drawingOpen.focus());
  }

  // Phones: the chat button steps aside while an add-to-basket button passes under it — komto-chat.js (all pages)

  window.addEventListener('hashchange', () => openDetailsFor(window.location.hash));
  if (window.location.hash) openDetailsFor(window.location.hash);

  // Mobile section rail (mobile-product-fixes, BAN-179). The tab of the section under a line at 40% of the screen is
  // marked; a tab whose section sits inside another (Delivery inside Details) wins while its own box is under the
  // line, then the outer one takes over again. Tabs follow the sections' order on the page. Below the last section
  // (recommendations, footer) no tab is marked and the rail lets go (body.komto-rail-done).
  const rail = document.querySelector('[data-komto-rail]');
  if (rail) {
    const find = (sel) => {
      try {
        return document.querySelector(sel);
      } catch (e) {
        return null;
      }
    };
    const items = Array.from(rail.querySelectorAll('a[href^="#"]'))
      .map((link) => {
        const target = find(link.getAttribute('href'));
        if (!target) {
          link.hidden = true;
          return null;
        }
        // Reviews: the section head above the Judge.me widget and the widget's own section belong to the same tab
        if (target.id === 'judgeme_product_reviews') {
          return { link, start: find('#komto-reviews') || target, end: target.closest('.shopify-section') || target };
        }
        return { link, start: target, end: target };
      })
      .filter(Boolean);
    const top = (el) => el.getBoundingClientRect().top;
    items.sort((a, b) => top(a.start) - top(b.start));
    items.forEach((item) => rail.appendChild(item.link));

    let raf = 0;
    const mark = () => {
      raf = 0;
      const line = window.innerHeight * 0.4;
      let active = null;
      let passed = null;
      let lastBottom = -Infinity;
      items.forEach((item) => {
        const t = top(item.start);
        const b = item.end.getBoundingClientRect().bottom;
        lastBottom = Math.max(lastBottom, b);
        if (t <= line && b > line) active = item; // the later (inner) one wins
        if (t <= line) passed = item;
      });
      // between two sections (the features band) the last one passed stays marked
      if (!active) active = passed || items[0] || null;
      // let go as soon as the next section (recommendations) takes the lower 40% of the screen
      const done = items.length > 0 && lastBottom <= window.innerHeight * 0.6;
      document.body.classList.toggle('komto-rail-done', done);
      items.forEach((item) => {
        const on = item === active && !done;
        item.link.classList.toggle('is-active', on);
        if (on) item.link.setAttribute('aria-current', 'true');
        else item.link.removeAttribute('aria-current');
      });
      if (active && rail.scrollWidth > rail.clientWidth) {
        const l = active.link;
        if (l.offsetLeft < rail.scrollLeft || l.offsetLeft + l.offsetWidth > rail.scrollLeft + rail.clientWidth) {
          rail.scrollTo({ left: l.offsetLeft - 16, behavior: 'smooth' });
        }
      }
    };
    const fits = () => {
      rail.classList.toggle('is-overflowing', rail.scrollWidth > rail.clientWidth + 1);
      rail.classList.toggle('is-scrolled-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2);
    };
    const queue = () => {
      if (!raf) raf = requestAnimationFrame(mark);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', () => {
      queue();
      fits();
    });
    rail.addEventListener('scroll', fits, { passive: true });
    // Judge.me and the recommendations grow after load without a scroll event: mark again when the page resizes
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(document.body);
    queue();
    fits();
  }
})();
